// src/playback-runtime/playbackBus.ts

// Global arbitration channel for all players
// Ensures only ONE active playback across the app

type PlaybackKind = "audio" | "video";

type Listener = (activeId: string | null) => void;

class PlaybackBus {
  private activeId: string | null = null;
  private listeners = new Set<Listener>();

  /* request playback ownership */
  request(id: string) {
    if (this.activeId === id) return;

    this.activeId = id;
    this.emit();
  }

  /* release ownership */
  release(id: string) {
    if (this.activeId !== id) return;
    this.activeId = null;
    this.emit();
  }

  /* subscribe */
  subscribe(cb: Listener) {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }

  private emit() {
    for (const l of this.listeners) l(this.activeId);
  }
}

export const playbackBus = new PlaybackBus();
